import type { PageOptions } from '../api.types';

export interface UploadProps {
  file: File;
  type: 'document' | 'image' | 'video';
}

export interface UploadResponse {
  id: string;
  type: DocumentType;
  filename: string;
  public_path: string;
}

export enum DocumentType {
  RESUME = 'resume',
  COVER_LETTER = 'cover_letter',
  CERTIFICATE = 'certificate',
  VISA = 'visa',
  DRIVING_LICENSE = 'driving_license',
  OTHER_LICENSE = 'other_license',
  INSURANCE_DOCUMENT = 'insurance_document',
  TAX_DOCUMENT = 'tax_document',
  PASSPORT = 'passport',
  TERMS_OF_BUSINESS = 'terms_of_business',
  SYSTEM_DOCUMENT = 'system_document',

  PROPOSAL = 'proposal',
  CLIENT_AGREEMENTS = 'client_agreements',
  INTERNAL_COMPLIANCE_DOCUMENTS = 'internal_compliance_documents',
  JOB_DESCRIPTIONS = 'job_descriptions',
  POSITION_CONTRACTS = 'position_contracts',
  FEE_SCHEDULES = 'fee_schedules',
  VENDOR_AGREEMENTS = 'vendor_agreements',
  POLICIES_PROCEDURES = 'policies_procedures',
  PURCHASE_ORDERS = 'purchase_orders',
  INVOICES = 'invoices',
  ONBOARDING_DOCUMENTS = 'onboarding_documents',
  TRAINING_MATERIALS = 'training_materials',
  TIMESHEETS = 'timesheets',
  MEETING_MINUTES = 'meeting_minutes',

  OTHER = 'other',
}

export const CandidateDocumentTypes = [
  DocumentType.RESUME,
  DocumentType.COVER_LETTER,
  DocumentType.CERTIFICATE,
  DocumentType.VISA,
  DocumentType.DRIVING_LICENSE,
  DocumentType.OTHER_LICENSE,
  DocumentType.INSURANCE_DOCUMENT,
  DocumentType.TAX_DOCUMENT,
  DocumentType.PASSPORT,
  DocumentType.OTHER,
];

export const OrganizationDocumentTypes = [
  DocumentType.RESUME,
  DocumentType.COVER_LETTER,
  DocumentType.CERTIFICATE,
  DocumentType.VISA,
  DocumentType.DRIVING_LICENSE,
  DocumentType.OTHER_LICENSE,
  DocumentType.INSURANCE_DOCUMENT,
  DocumentType.TAX_DOCUMENT,
  DocumentType.PASSPORT,


  DocumentType.TERMS_OF_BUSINESS,
  DocumentType.PROPOSAL,
  DocumentType.CLIENT_AGREEMENTS,
  DocumentType.INTERNAL_COMPLIANCE_DOCUMENTS,
  DocumentType.JOB_DESCRIPTIONS,
  DocumentType.POSITION_CONTRACTS,
  DocumentType.FEE_SCHEDULES,
  DocumentType.VENDOR_AGREEMENTS,
  DocumentType.POLICIES_PROCEDURES,
  DocumentType.PURCHASE_ORDERS,
  DocumentType.INVOICES,
  DocumentType.ONBOARDING_DOCUMENTS,
  DocumentType.TRAINING_MATERIALS,
  DocumentType.TIMESHEETS,
  DocumentType.MEETING_MINUTES,
  
  DocumentType.OTHER,
];

export const OfferDocumentTypes = [
  DocumentType.RESUME,
  DocumentType.COVER_LETTER,
  DocumentType.CERTIFICATE,
  DocumentType.VISA,
  DocumentType.DRIVING_LICENSE,
  DocumentType.OTHER_LICENSE,
  DocumentType.INSURANCE_DOCUMENT,
  DocumentType.TAX_DOCUMENT,
  DocumentType.PASSPORT,
  DocumentType.OTHER,
];

export interface CreateDocumentProps {
  organization_id: string;
  document: CreateDocumentData;
}

export interface CreateDocumentData {
  file_id: string;
  name: string;
  type: DocumentType;
}

export interface CreateDocumentResponse {
  id: string;
  name: string;
  type: DocumentType;
  file: DocumentFile;
  created_at: string;
}

export type GetOrganisationDocumentsProps = {
  organization_id: string;
  search_query?: string | undefined;
  type?: DocumentType | undefined;
} & PageOptions;

export interface OrganisationDocument {
  id: string;
  name: string;
  type: DocumentType;
  custom_type_name?: string;
  file: DocumentFile;
}

export interface DocumentFile {
  id: string;
  file_id: string;
  filename: string;
  public_path: string;
  type: DocumentType;
  mime: string;
  created_at: string;
  name?: string;
  /** The document's own name, before any title set on an application or candidate record. */
  original_name?: string;
  custom_type_name?: string;
}

export interface GetConnectionDocumentsProps {
  organization_id: string;
  connection_id: string;
}

export type ConnectionDocumentsResponse = OrganisationDocument[];
